import React from "react";
import Logo from "../assets/images/payloft-logo.png";

const TransactionFailed = () => {
  return (
    <div className="bg-arena-background h-min-screen flex justify-center">
      <div className="bg-white w-[448px] h-auto">
        <div className="flex justify-center">
          <img src={Logo} alt="logo" className="w-[92px] h-auto mt-8 " />
        </div>
        <div className="mt-8 flex justify-center text-center">
          <p className="text-[18.75px] w-[348px] text-paragraph-text">
            Payment of the amount has been confirmed
          </p>
        </div>
        <div>
          <div className="flex justify-center mt-8">
            <svg
              width="70"
              height="71"
              viewBox="0 0 70 71"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.000166306 36.0646C0.000166389 34.1628 0.143698 32.2251 0.466643 30.2874C2.83492 15.6113 14.7481 3.66226 29.4242 1.29398C48.2987 -1.75607 66.0967 10.4083 69.9003 29.0315C70.1873 30.5027 69.2544 31.9022 67.819 32.2251C66.3478 32.5122 64.9484 31.5792 64.6255 30.1439C61.396 14.3913 46.3251 4.05697 30.2854 6.67643C17.8699 8.68588 7.78678 18.769 5.77733 31.1845C3.19375 47.296 13.5639 62.331 29.3883 65.5246C30.8595 65.8116 31.7925 67.2469 31.5054 68.6823C31.2184 70.1535 29.7831 71.0864 28.3477 70.7994C11.5904 67.3905 0.000165577 52.7502 0.000166306 36.0646Z"
                fill="#FF0000"
              />
              <path
                d="M47.8433 24.0003C46.9677 23.1247 45.5522 23.1247 44.6766 24.0003L36.5004 32.1598L28.3234 23.9829C27.4478 23.1073 26.0323 23.1073 25.1567 23.9829C24.2811 24.8584 24.2811 26.274 25.1567 27.1496L33.3333 35.3262L25.1567 43.5028C24.2811 44.3783 24.2811 45.7939 25.1567 46.6695C26.0323 47.5451 27.4478 47.5451 28.3234 46.6695L36.5 38.4929L44.6766 46.6695C45.5522 47.5451 46.9677 47.5451 47.8433 46.6695C48.7189 45.7939 48.7189 44.3783 47.8433 43.5028L39.6667 35.3262L47.8433 27.1496C48.7014 26.2914 48.7014 24.8584 47.8433 24.0003Z"
                fill="#FF0000"
                stroke="#FF0000"
              />
            </svg>
          </div>
          <div className="flex flex-col items-center mt-8">
            <p className="w-[240.45px] text-2xl font-semibold text-dark-grey text-center">
              Transaction Unsuccessful
            </p>
            <p className="text-dark-grey text-sm font-normal">
              Your transaction was not successful
            </p>
          </div>
        </div>
        <div className="px-4 mt-8">
          <p className="text-bold-orange text-base font-medium">
            Payment Details
          </p>
          <div className="flex justify-between mt-4">
            <p className="font-normal text-[13px] text-dark-grey">Amount</p>
            <p className="text-[13px] text-dark-grey font-medium">
              ₦1,000,000.00
            </p>
          </div>
          <div className="flex justify-between mt-4">
            <p className="font-normal text-[13px] text-dark-grey">
              Transaction Fee
            </p>
            <p className="text-[13px] text-dark-grey font-medium">₦26.88</p>
          </div>
          <div className="flex justify-between mt-4">
            <p className="font-normal text-[13px] text-dark-grey">
              Transaction Type
            </p>
            <p className="text-[13px] text-dark-grey font-medium">
              Pay By Transfer
            </p>
          </div>
          <div className="flex justify-between mt-4">
            <p className="font-normal text-[13px] text-dark-grey">
              Reference no
            </p>
            <p className="text-[13px] text-dark-grey font-medium">
              7912369763912879761114
            </p>
          </div>
          <div className="flex justify-between mt-4 border-b-2 pb-4 border-dashed">
            <p className="font-normal text-[13px] text-dark-grey">
              Payment Status
            </p>
            <div className="flex items-center gap-1">
              <span>
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.99967 1.98926C4.32634 1.98926 1.33301 4.98259 1.33301 8.65592C1.33301 12.3293 4.32634 15.3226 7.99967 15.3226C11.673 15.3226 14.6663 12.3293 14.6663 8.65592C14.6663 4.98259 11.673 1.98926 7.99967 1.98926ZM11.1863 7.12259L7.40634 10.9026C7.31301 10.9959 7.18634 11.0493 7.05301 11.0493C6.91967 11.0493 6.79301 10.9959 6.69967 10.9026L4.81301 9.01592C4.61967 8.82259 4.61967 8.50259 4.81301 8.30926C5.00634 8.11592 5.32634 8.11592 5.51967 8.30926L7.05301 9.84259L10.4797 6.41592C10.673 6.22259 10.993 6.22259 11.1863 6.41592C11.3797 6.60926 11.3797 6.92259 11.1863 7.12259Z"
                    fill="#23A26D"
                  />
                </svg>
              </span>
              <p className="text-[13px] text-dark-grey font-medium">Success</p>
            </div>
          </div>
          <div className="flex justify-between mt-4">
            <p className="font-normal text-[13px] text-dark-grey">
              Total Payment
            </p>
            <p className="text-base text-dark-grey font-bold">₦1,000,026.88</p>
          </div>
        </div>
        <div className="flex justify-center mt-10">
          <button className="border bg-text-orange text-white w-[307px] rounded-[10px] h-[65.38px]">
            Retry Transaction
          </button>
        </div>
        <p className="text-center text-base font-normal text-navy-blue mt-5 mb-5">
          Powered by Payloft
        </p>
      </div>
    </div>
  );
};

export default TransactionFailed;
